import { useContext, useEffect, useState, useCallback } from "react";
import { Box, Typography, CircularProgress } from "@mui/joy";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import QuizRoundedIcon from "@mui/icons-material/QuizRounded";

import PageHeader from "../components/ui/PageHeader";
import PageContainer from "../components/ui/PageContainer";
import EmptyState from "../components/ui/EmptyState";
import { LayoutContext } from "../context";
import QuizCard from "../components/Quiz/QuizCard";
import QuizRunner from "../components/Quiz/QuizRunner";
import MyQuizzesSummary from "../components/Quiz/MyQuizzesSummary";
import { APIGetQuizzes } from "../api_quiz";

export default function QuizzesPage() {
  const { token } = useContext(LayoutContext);
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeCode, setActiveCode] = useState(null);

  const load = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const data = await APIGetQuizzes(token);
      setQuizzes(data.quizzes || []);
    } catch (e) {
      setError("Не удалось загрузить тесты");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const done = quizzes.filter(q => q.is_completed).length;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
      <PageHeader
        title="Тесты"
        subtitle={quizzes.length ? `Пройдено ${done} из ${quizzes.length}` : undefined}
      />

      <PageContainer>
        <Typography level="body-sm" sx={{ color: "var(--lvc-ink-soft)", maxWidth: 620, mb: 2.5 }}>
          Пройдите короткие тесты — так подбор станет точнее, а в анкетах появится процент совместимости.
        </Typography>

        <Box sx={{ mb: 2.5 }}>
          <MyQuizzesSummary quizzes={quizzes} />
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <EmptyState
            icon={<RefreshRoundedIcon />}
            title="Тесты не загрузились"
            text={error}
            action={
              <button type="button" className="lvc-btn lvc-btn--primary" onClick={load}>
                <RefreshRoundedIcon sx={{ fontSize: 17 }} />
                Попробовать снова
              </button>
            }
          />
        ) : quizzes.length === 0 ? (
          <EmptyState
            icon={<QuizRoundedIcon />}
            title="Пока нет доступных тестов"
            text="Как только появятся новые тесты, они окажутся здесь — и сразу повлияют на подбор анкет."
          />
        ) : (
          <Box className="lvc-grid">
            {quizzes.map((q, i) => (
              <QuizCard key={q.id} quiz={q} index={i} onOpen={(quiz) => setActiveCode(quiz.code)} />
            ))}
          </Box>
        )}
      </PageContainer>

      <QuizRunner
        open={!!activeCode}
        code={activeCode}
        token={token}
        onClose={() => setActiveCode(null)}
        onCompleted={() => load()}
      />
    </Box>
  );
}
